

export const index = 6;
export const component = async () => (await import('../entries/pages/services/_page.svelte.js')).default;
export const file = '_app/immutable/components/pages/services/_page.svelte-211b097f.js';
export const imports = ["_app/immutable/components/pages/services/_page.svelte-211b097f.js","_app/immutable/chunks/index-d33e9054.js","_app/immutable/chunks/index-11f5cf22.js","_app/immutable/chunks/CardText-14eef0cb.js"];
export const stylesheets = ["_app/immutable/assets/CardText-ccb86115.css"];
